<template>
  <div>
    <div class="my-exam-head">
      <div class="my-exam-head-flex">
        <div class="programme nowrap" @click="iShow=true">
          <span class="nowrap">{{pName}}</span>
          <van-icon name="arrow-down" />
        </div>
        <div @click="goHistory" class="history">历史记录</div>
      </div>
    </div>
    <div class="my-exam-body">
      <div v-for="item in list" :key="item.ExamDate" class="list">
        <ul class="list-ul">
          <li v-for="child in item.Subjects" :key="child.SeatNumber" class="list-li">
            <div class="exam-subject nowrap">
              <div class="exam-subject-name nowrap">
                <img :src="require('@/assets/educationAffairs/subject.png')" alt="">
                <span>{{child.SubjectName}}</span>
              </div>
              <div class="exam-subject-number"><b>{{child.StudentCount}}</b>&nbsp;<span>人</span></div>
            </div>
            <div class="list-li-exam exam-times nowrap"><i class="iconfont">&#xe608;</i>{{item.ExamDate}}{{child.SubjectExamTime}}</div>
            <div class="list-li-exam exam-address nowrap"><i class="iconfont">&#xe60e;</i>{{child.ExamRoomName}}（{{child.ExamRoomAddress}}）</div>
          </li>
        </ul>
      </div>
    </div>
    <van-action-sheet
      v-model="iShow"
      :actions="pList"
      description="切换方案"
      @select="selectProgram"
    />
  </div>
</template>
<script>
export default {
  name:'myexam',
  data(){
    return {
      pName:'',
      iShow:false,
      yearId:'',
      sessionId:'',
      pList:[],
      list:[]
    }
  },
  created(){
    this.getSessionNodeList()
  },
  methods:{
    async getSessionNodeList(){//获取学年学期
      this.xy.loading()
      let res = await this.xyapi.get(`${this.xyMApi}/xy/Comm/GetSessionNodeList`, null)
      this.xy.unloading()
      if(res.success){
        if(res.data.length>0){
          res.data.map(item=>{
            if(item.IsCurrent){
              this.yearId=item.value//当前学年
              item.children.map(child=>{
                if(child.IsCurrent){
                  this.sessionId=child.value//当前学期
                }
              })
            }
          })
        }
        if(this.yearId!=='' && this.sessionId!=='') this.getProgramme()
        else {
          res.data.map(item => {
            if(item.ischild) {
              this.yearId = item.value
              this.sessionId = item.children[0].value
            } else {
              this.yearId = 0
              this.sessionId = 0
            }
          })
          this.getProgramme()
        }
      }
    },
    async getProgramme(){//获取方案
      let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/ArrangeSupervisorExam/GetArrangeSupervisorByTeacherMobile`, {
        AcademicYearID: this.yearId,
        AcademicSessionID: this.sessionId,
        IsDateAfter:true
      });
      this.xy.unloading()
      if(res.success){
        let datas = res.data;
        if(datas.length>0) {
          datas.map(item => {
            this.pList.push({
              name:item.ArrangeSupervisorExamName,
              id:item.ArrangeSupervisorExamID
            })
          })
          this.pName = this.pList[0].name
          this.pId = this.pList[0].id
          this.getExam()
        }else{
          this.xy.unloading()
        }
      }
    },
    async getExam(){//获取考试信息
      this.xy.loading()
      let res = await this.xyapi.post(`${this.$store.state.apiPath}/api/MyInvigilator/GetTeacherExamByID?ArrangeSupervisorExamID=${this.pId}`,null);
      this.xy.unloading()
      this.list= res.success ? res.data : []
    },
    selectProgram(item){//切换方案
      this.iShow=false;
      this.pName=item.name;
      if(this.pId!==item.id){
        this.pId = item.id;
        this.getExam()
      }
    },
    goHistory(){
      this.$router.push('/home/examManage/myInvigilateHistory')
    }
  }
}
</script>
<style lang="less" scoped>
.my-exam-head{
  height: 150px;
  background-image: url('../../../../assets/educationAffairs/bg_mobile.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .my-exam-head-flex{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding:30px 50px 0;
    .programme{
      width: 300px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 26px;
      color:#fff;
      background: rgba(35, 97, 211, 1);
      border-radius: 60px;
      padding:15px 20px;
      span{
        padding-right: 16px;
      }
    }
    .history{
      font-size: 26px;
      color: #fff;
    }
  }
  .my-exam-head-card{
    padding:30px 50px 0;
    div{
      width: 100%;
      height: 60px;
      line-height: 60px;
      padding: 0 0.5rem;
      text-align: center;
      color: rgba(255, 255, 255, 1);
      background: rgba(35, 97, 211, .5);
      border-radius: 30px;
      font-size: 26px;
      span{
        font-size: 30px;
      }
    }
  }
}
.my-exam-body{
  width: 90%;
  margin: 0 auto;
  padding: 0 20px 20px;
  .list{
    .list-ul{
      .list-li{
        display: flex;
        flex-flow: column;
        padding: 20px 0 20px 20px;
        margin-bottom: 20px;
        height: 200px;
        margin-top: 10px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 6px 0px rgba(166, 187, 207, 0.3);
        border-radius: 12px;
        position: relative;
        .exam-subject{
          height: 68px;
          display: flex;
          justify-content:space-between;
          align-items: center;
          margin-bottom: 10px;
          .exam-subject-name{
            font-size: 30px;
            font-weight: bold;
            span{
              margin-left: 20px;
            }
          }
          .exam-subject-number{
            background: #ffac4b;
            color: #fff;
            border-radius: 22px 2px 2px 22px;
            padding: 8px 14px;
            span{
              font-size: 22px;
            }
            b{
              font-size: 28px;
            }
          }
        }
        .list-li-exam{
          font-size: 28px;
          margin-bottom: 10px;
          padding-right: 40px;
          .iconfont{
            font-size: 24px;
            margin:0 20px 0 10px;
            color: #ccc;
          }
        }
      }
    }

  }
}
</style>
